module.exports = __webpack_public_path__ + "static/media/nim1.0fdfae20.png";